/// <amd-module name="Repos/Views/PullRequest/Util/Reviewer" />
import { IReviewer } from "Repos/Views/PullRequest/Contracts/PullRequest";
import { IRequiredReviewersPolicyEvaluation } from "../Contracts/PullRequest";
import { hasApproved } from "./Vote";

export type IRequiredReviewerPolicyLookup = { [reviewerId: string]: IRequiredReviewersPolicyEvaluation[] };

/**
 * Create a mapping from a user to the set of required policies for that user
 *
 * @param policies List of required-reviewer policies
 */
export function createReviewerPolicyLookup(policies: IRequiredReviewersPolicyEvaluation[]): IRequiredReviewerPolicyLookup {
    const lookup: IRequiredReviewerPolicyLookup = {};
    for (const policy of policies) {
        if (policy.requiredReviewerIds) {
            for (const reviewer of policy.requiredReviewerIds) {
                let reviewerPolicies = lookup[reviewer];
                if (!reviewerPolicies) {
                    reviewerPolicies = [];
                    lookup[reviewer] = reviewerPolicies;
                }
                reviewerPolicies.push(policy);
            }
        }
    }
    return lookup;
}

export function getBlockingRequiredReviewers(reviewers: IReviewer[]): IReviewer[] {
    return reviewers.filter(r => r.baseReviewer.isRequired && !hasApproved(r.vote));
}
